export default "__VITE_ASSET__CHwge5CF__"